import type { Reference } from '../data/types'

interface ReferencesBlockProps {
    references: [Reference, Reference, Reference];
}

function renderText(text: string, italicPhrase?: string) {
    if (!italicPhrase) return text
    const index = text.indexOf(italicPhrase)
    if (index === -1) return text

    return (
        <>
            {text.slice(0, index)}
            <cite>{italicPhrase}</cite>
            {text.slice(index + italicPhrase.length)}
        </>
    )
}

// Sits between the closing CTA and the footer. Structure and build notes from
// content/unimo-industry-page-copy.md, "Citations" — real anchors, a real
// heading in the document outline, outbound links open in a new tab.
export function ReferencesBlock({ references }: ReferencesBlockProps) {
    return (
        <section className="border-t border-unimo-site-grey-300 pb-4 pt-4">
            <h2 className="mb-3 text-[11px] font-medium uppercase tracking-wide text-unimo-site-grey-700">
                References
            </h2>
            <ol className="max-w-xl space-y-1.5">
                {references.map((reference) => (
                    <li key={reference.id} id={`ref-${reference.id}`} className="scroll-mt-8 text-xs font-light leading-snug text-unimo-slate">
                        {reference.id}. {renderText(reference.text, reference.italicPhrase)}{' '}
                        <a
                            href={reference.url}
                            target="_blank"
                            rel="noopener"
                            className="underline"
                        >
                            {reference.linkLabel}
                        </a>{' '}
                        <a href={`#cite-${reference.id}`} aria-label={`Back to reference ${reference.id} in the text`}>
                            ↩
                        </a>
                    </li>
                ))}
            </ol>
        </section>
    )
}

export default ReferencesBlock
